export function validatePassword(p) {
    let error = '';
    const hint = null;
    let valid = true;
    if (!p) {
        error = 'At least 8 letters';
        // error = t('msg.error.signUpRules.completeRuleSet');
        valid = false;
    }
    else {
        if (!(p.length >= 8)) {
            error += 'At least 8 letters. ';
            // error += t('msg.error.signUpRules.atLeast8Char');
            valid = false;
        }
    }
    return { error, valid, hint };
}
/**
 * Sentinel value the backend returns in `view.password` / `dashboard.password`
 * when a password is set. The bcrypt hash never leaves the backend; the
 * frontend sees this sentinel and renders a masked state instead.
 *
 * The frontend echoes this value back on subsequent updates to signal
 * "password unchanged" — the backend strips it from the update payload
 * so the stored hash is not re-hashed.
 */
export const NC_VIEW_PASSWORD_PROTECTED_SENTINEL = '__NC_PASSWORD_MASKED__';
/**
 * Returns true when `value` looks like a bcrypt hash. Matches every bcrypt
 * variant prefix (`$2a$` / `$2b$` / `$2y$`) — bcryptjs emits `$2a$`/`$2b$`
 * today, the broader match keeps the guard correct if the hashing library
 * ever changes. Centralised so backend models (`View`, `Dashboard`) and the
 * frontend realtime handlers share one definition.
 */
export const isBcryptHash = (value) => {
    return typeof value === 'string' && /^\$2[aby]\$/.test(value);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFzc3dvcmRIZWxwZXJzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9wYXNzd29yZEhlbHBlcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxVQUFVLGdCQUFnQixDQUFDLENBQUM7SUFDaEMsSUFBSSxLQUFLLEdBQUcsRUFBRSxDQUFDO0lBQ2YsTUFBTSxJQUFJLEdBQUcsSUFBSSxDQUFDO0lBQ2xCLElBQUksS0FBSyxHQUFHLElBQUksQ0FBQztJQUVqQixJQUFJLENBQUMsQ0FBQyxFQUFFLENBQUM7UUFDUCxLQUFLLEdBQUcsb0JBQW9CLENBQUM7UUFDN0Isc0RBQXNEO1FBQ3RELEtBQUssR0FBRyxLQUFLLENBQUM7SUFDaEIsQ0FBQztTQUFNLENBQUM7UUFDTixJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsTUFBTSxJQUFJLENBQUMsQ0FBQyxFQUFFLENBQUM7WUFDckIsS0FBSyxJQUFJLHNCQUFzQixDQUFDO1lBQ2hDLG9EQUFvRDtZQUNwRCxLQUFLLEdBQUcsS0FBSyxDQUFDO1FBQ2hCLENBQUM7SUFDSCxDQUFDO0lBQ0QsT0FBTyxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFFLENBQUM7QUFDaEMsQ0FBQztBQUVEOzs7Ozs7OztHQVFHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sbUNBQW1DLEdBQUcsd0JBQXdCLENBQUM7QUFFNUU7Ozs7OztHQU1HO0FBQ0gsTUFBTSxDQUFDLE1BQU0sWUFBWSxHQUFHLENBQUMsS0FBYyxFQUFtQixFQUFFO0lBQzlELE9BQU8sT0FBTyxLQUFLLEtBQUssUUFBUSxJQUFJLGFBQWEsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUM7QUFDaEUsQ0FBQyxDQUFDIn0=